var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLeadCaptureLandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 161,
    viewBox: "0 0 390 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231 7H131V145H231V7Z",
    fill: "#67DDE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219 7H143V121H219V7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.703 49.7773H206.851",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.703 59.2588H206.851",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.703 68.7402H206.851",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.703 78.2217H206.851",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.703 87.7031H206.851",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.703 97.1846H192.629",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219 7V121H143V7",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M207 36H188",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M231 7H131V145H231V7Z",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204 2H157V21H204V2Z",
    fill: "#F28C13"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204 2H157V21H204V2Z",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M259 71.1113H244.777V106.667H259V71.1113Z",
    fill: "#FFB957"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M259 21.3335H244.777V71.1113H259V21.3335Z",
    fill: "#F28C13"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259 7.11133H244.777V21.3336H259V7.11133Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M244.777 106.667V21.3335",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M259 21.3335V106.667",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M259 7.11133H244.777V21.3336H259V7.11133Z",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259 106.667V118.518L251.888 125.629L244.777 118.518V106.667H259Z",
    fill: "#ACF0F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M259 106.667V118.518L251.888 125.629L244.777 118.518V106.667H259Z",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M251.889 7.11111V0",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M251.889 125.629V130.37",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M251.889 94.815V90.0742",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M251.889 85.3335V80.5928",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M168.926 132.74H173.667",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.408 132.74H183.149",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.889 132.74H192.629",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M164 12H197",
    stroke: "#4D5152",
    strokeWidth: 3.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLeadCaptureLandscape);
export default __webpack_public_path__ + "static/media/login-lead-capture-landscape.bf7df48d740fbae6c4ebfe81dc3a33c3.svg";
export { ForwardRef as ReactComponent };